import { useCutReducedData } from './useCutReducedData'
import { useMemo } from 'react'
import { reduce } from '../functions/reduce'
import { useMaxCachedReducedDataLength } from './useMaxCachedReducedDataLength'

interface Props {
  source: Float32Array
  zoomStep: number
}

export function useMaxCachedReducedData({ source, zoomStep }: Props) {
  const cutReducedData = useCutReducedData()
  const maxCachedReducedDataLength = useMaxCachedReducedDataLength(zoomStep)
  const reducedSource = useMemo(() => reduce(source, maxCachedReducedDataLength), [source, maxCachedReducedDataLength])
  return useMemo(
    () => cutReducedData(reducedSource, reducedSource.length / source.length),
    [reducedSource, source, cutReducedData],
  )
}
